// extracted by mini-css-extract-plugin
export default {"WillBeAvailableLater":"WillBeAvailableLater_WillBeAvailableLater__+TQpv","content":"WillBeAvailableLater_content__vxylh","icon":"WillBeAvailableLater_icon__e8Rwz"};